// www/src/components/AddonEditor.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config';

export default function AddonEditor({ addon, onDone, onCancel }) {
  const { authenticatedFetch } = useAuth();
  const [form, setForm] = useState(() => addon ? {
    id: addon.id,
    name: addon.name,
    description: addon.description || '',
    priceDelta: String(addon.priceDelta),
    durationDelta: String(addon.durationDelta),
    published: !!addon.published,
    sortOrder: String(addon.sortOrder || 0),
  } : {
    name: '', description: '', priceDelta: '0', durationDelta: '0', published: true, sortOrder: '0',
  });
  const [saving, setSaving] = useState(false);

  function update(field, value) { setForm((f) => ({ ...f, [field]: value })); }

  async function onSave(e) {
    e.preventDefault();
    setSaving(true);
    const body = {
      name: form.name,
      description: form.description || null,
      priceDelta: Number(form.priceDelta) || 0,
      durationDelta: Number(form.durationDelta) || 0,
      published: !!form.published,
      sortOrder: Number(form.sortOrder) || 0,
    };
    const url = form.id ? `${API_BASE_URL}/api/addons/${form.id}` : `${API_BASE_URL}/api/addons`;
    const method = form.id ? 'PUT' : 'POST';
    const res = await authenticatedFetch(url, {
      method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
    });
    setSaving(false);
    if (!res.ok) { const err = await res.json().catch(() => ({})); alert(err.error || 'Save failed'); return; }
    onDone();
  }

  return (
    <form className="service-editor" onSubmit={onSave}>
      <h2>{form.id ? 'Edit Add-on' : 'New Add-on'}</h2>
      <label>Name <input value={form.name} onChange={(e) => update('name', e.target.value)} required /></label>
      <label>Description <textarea rows={3} value={form.description} onChange={(e) => update('description', e.target.value)} /></label>
      <label>Price delta ($) <input type="number" step="0.01" value={form.priceDelta} onChange={(e) => update('priceDelta', e.target.value)} /></label>
      <label>Duration delta (min) <input type="number" value={form.durationDelta} onChange={(e) => update('durationDelta', e.target.value)} /></label>
      <label><input type="checkbox" checked={form.published} onChange={(e) => update('published', e.target.checked)} /> Published</label>
      <label>Sort order <input type="number" value={form.sortOrder} onChange={(e) => update('sortOrder', e.target.value)} /></label>

      <div className="editor-actions">
        <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
        <button type="button" className="btn-secondary" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
